import { createFileRoute, redirect } from '@tanstack/react-router'

import { AccountRoute } from '@/pages/account/route-entries/account'
import {
  changedEmailTokenVerificationSchema,
  defaultTokenVerificationSchema,
} from '@/pages/account/search-schema'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/user/account')({
  component: AccountRoute,
  validateSearch: (search) =>
    changedEmailTokenVerificationSchema.catch(defaultTokenVerificationSchema).parse(search),
  loaderDeps: ({ search }) => {
    return { search }
  },
  loader: ({ deps: { search } }) => {
    if (search.token?.length === 0) {
      throw redirect({
        to: '.',
        search: (prev) => ({
          ...prev,
          token: undefined,
        }),
        replace: true,
      })
    }
  },
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Account Management'),
        },
      ],
    }
  },
})
